import Skeleton from 'react-loading-skeleton';

import Container from '@/components/@base/container';
import Loading from '@/components/shared/components/search/result/skeleton/loading';

export default function SkeletonResults() {
  return (
    <Container>
      <Container>
        <Skeleton width={160} height={16} />
        <Loading />
        <Loading />
      </Container>
      <Container className='mt-4'>
        <Skeleton width={160} height={16} />
        <Loading />
        <Loading />
      </Container>
      <Container className='mt-4'>
        <Skeleton width={349} height={16} />
        <Skeleton width={349} height={16} className='my-10' />
        <Skeleton width={349} height={16} />
      </Container>
    </Container>
  );
}
